import SparklingBullet from '../assets/icons/sparkling.png';

const Bullet = () => (
  <img width='28' height='28' src={SparklingBullet} alt='sparkling icon' />
);

export default Bullet;
